export default __webpack_public_path__ + "static/media/status-success.04ba5ef1.svg";